import * as classnames from 'classnames'
import * as React from 'react'

import { ILocationParams } from '../../../common/reducers/reactRouterLocation'

import * as styles from './button.module.css'

type ButtonAnchorHTMLAttributes = React.ButtonHTMLAttributes<
  HTMLButtonElement
> &
  React.AnchorHTMLAttributes<HTMLAnchorElement>

interface IProps extends ButtonAnchorHTMLAttributes {
  large?: boolean
  primary?: boolean
  fixedWidth?: boolean
  tag?: React.ComponentType<any>
  locationParams?: ILocationParams
}

const Button = (props: IProps) => {
  const {
    className,
    children,
    large,
    primary,
    fixedWidth,
    tag,
    ...nextProps
  } = props
  const Tag: any = tag ? tag : tagType(nextProps.href)
  const nextClassName = classnames(styles.button, className, {
    [styles.large]: large,
    [styles.primary]: primary,
    [styles.fixedWidth]: fixedWidth
  })

  return (
    <Tag className={nextClassName} {...nextProps}>
      {children}
    </Tag>
  )
}

const tagType = (href: string | undefined) => {
  return href ? 'a' : 'button'
}

export default Button
